module.exports = __webpack_public_path__ + "static/img/PC.cc0a7bd8.svg";